// Assets
import userImage1 from "src/assets/mock_images/user_image.png";

export const getTalksAboutUs = (): TalkAboutUsComment[] => {
    return [
        {
            id: 1,
            message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
            name: "Somchai suksubuy",
            userImage: userImage1
        },
        {
            id: 2,
            message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
            name: "Somchai suksubuy",
            userImage: userImage1
        },
        {
            id: 3,
            message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
            name: "Somchai suksubuy",
            userImage: userImage1
        }
    ];
};